export default __webpack_public_path__ + "static/media/Shuaa_splach_center.9405122e.png";